import { Network, Token } from 'config/types'
import useModal from 'hooks/useModal'
import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import ChainLogo from 'UIKit/TokenLogo/ChainLogo'
import { PaymentPageEnums } from 'views/Payment/Menu'
import SelectNetworkByCurrencyModal from './SelectNetworkByCurrencyModal'
import { PaymentChevronRightIcon, PaymentInputContainer, TextSelect } from './styles'

const SelectedNetworkItem: React.FC<{
  selectedToken: Token
  selectedNetwork: Network
  onSelectToken?: (network: Token) => void
  from: PaymentPageEnums
}> = ({ selectedToken, selectedNetwork, onSelectToken, from }) => {
  const disabled = !onSelectToken
  const [onPresent] = useModal(SelectNetworkByCurrencyModal)

  return (
    <PaymentInputContainer
      disabled={disabled}
      onClick={() =>
        !disabled &&
        onPresent({
          selectedToken,
          selectedNetwork,
          onSelectToken,
          from,
        })
      }
    >
      {selectedNetwork?.networkInfo ? (
        <RowMiddle flex={1} gap="8px">
          <ChainLogo width={20} height={20} network={selectedToken.network} />
          <TextSelect color="currentColor">{selectedNetwork?.networkInfo.displayName || 'Unknown'}</TextSelect>
        </RowMiddle>
      ) : (
        <RowMiddle flex={1} gap="8px">
          <TextSelect color="currentColor">
            <Trans>Choose Network</Trans>
          </TextSelect>
        </RowMiddle>
      )}

      {!disabled && (
        <RowMiddle width={12}>
          <PaymentChevronRightIcon />
        </RowMiddle>
      )}
    </PaymentInputContainer>
  )
}

export default SelectedNetworkItem
